(function () {
    'use strict';

    angular
        .module('app',
            [
                'auth',
                'services',
                'admin',
                'edufindme',
                'ui.router',
                'angular-jwt',
                'ngAnimate',
                'ngMask',
                'ui.bootstrap',
                'mgo-angular-wizard',
                'angular-loading-bar',
                'mm.acl',
                'ngAnimate',
                'mgcrea.ngStrap',
                'manage-workshops',
                'emails',
                'daterangepicker',
                'physicalFairs',
                'virtualFairs',
                'partners',
                'invoices',
                'costCenters',
                'payees',
                'expenses',
                'selectize',
                'angularFileUpload',
                'news',
                'ngRoute',
                'videosharing-embed',
                'generalReports',
                'highSchoolVisit',
                'webinar',
                'huddle',
                'countryDirective',
                'fuelux.wizard',
                'countryDirective',
                'ngWebworker',
                'ngTagsInput',
                'loyalty',
                'adm',
                'travelExpenses',
                'xeditable',
                '720kb.tooltips',
                'partner',
                'payroll',
                'angular-flot',
                'commissionsPayment',
                'uiCropper',
                'studyad',
                'ngLetterAvatar',
                'angular-popover',
                'financial',
                'platformRental',
                'tswApp',
                'notificationsPlatform',
                'statistics',
                'social',
                'surveys'
            ]).config(function($httpProvider) {
                $httpProvider.defaults.cache = false;
            });
})();